import { Injectable } from '@angular/core';
import { getCodeLangConfig } from '../domain/code-gen/code-lang.utils';
import { SupportedCodeLang } from '../domain/code-gen/code-lang.types';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CodeGeneratorService {

  /**
   * Generate code from a Blockly workspace for the specified code lang.
   *
   * @param codeLang - The target codelang to generate code for.
   * @param workspace - The Blockly workspace instance.
   * @returns Generated code, or a message.
   */
  generateCode(codeLang: SupportedCodeLang, workspace: unknown): string {
    const config = getCodeLangConfig(codeLang);
    if (!config) {
      this.log(`Invalid code lang config: ${codeLang}`);
      return 'Invalid code lang';
    }

    const { generatorName, commentSymbol } = config;
    const buildMessage = (message: string) => `${commentSymbol} ${message}\n`;

    const generator = this.resolveGenerator(generatorName);

    if (!generator?.workspaceToCode) {
      const ctx = 'Code generator unavailable';
      this.log(`${codeLang} ${ctx}`);
      return buildMessage(ctx);
    }

    try {
      return generator.workspaceToCode(workspace);
    } catch (err: unknown) {
      const ctx = `Error generating ${generatorName} code`;
      const msg = err instanceof Error ? err.message : String(err);
      this.log(`${ctx}: ${msg}`);
      return buildMessage(ctx);
    }
  }

  private resolveGenerator(name: string) {
    return Blockly?.[name];
  }

  private log = (message: unknown) =>
    console[environment.production ? 'warn' : 'error'](message);

}
